<template>
  <div class="d-flex flex-column ga-4">
    <v-alert type="info">
      {{ $t("ncrm.workflows.nodeSettings.crmWrite.bestPractice") }}
    </v-alert>
    <v-switch
      v-model="form.status"
      :true-value="'active'"
      :false-value="'inactive'"
      color="primary"
      hide-details
      :label="$t('ncrm.workflows.nodeSettings.active')"
    />
    <v-textarea
      v-model="form.description"
      :label="$t('ncrm.workflows.nodeSettings.description')"
      rows="3"
      hide-details="auto"
    />
    <v-divider />
    <div class="d-flex flex-column ga-3">
      <div>
        <div class="text-body-2 font-weight-semibold ncrm-text-strong">
          {{ $t("ncrm.workflows.nodeSettings.crmWrite.autoRunTitle") }}
        </div>
        <div class="text-caption text-medium-emphasis mt-1">
          {{ $t("ncrm.workflows.nodeSettings.crmWrite.autoRunHint") }}
        </div>
      </div>
      <v-switch
        v-model="form.autoRun"
        color="success"
        hide-details
        :label="form.autoRun ? $t('ncrm.workflows.nodeSettings.autoSyncOn') : $t('ncrm.workflows.nodeSettings.autoSyncOff')"
      />
      <v-select
        v-if="form.autoRun"
        v-model="form.autoRunIntervalMinutes"
        :items="intervalOptions"
        item-title="label"
        item-value="value"
        :label="$t('ncrm.workflows.nodeSettings.crmWrite.autoRunInterval')"
        hide-details="auto"
        :menu-props="selectMenuProps"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "NcrmWorkflowCrmWriteSettings",
  props: {
    form: { type: Object, required: true },
    intervalOptions: { type: Array, default: () => [] },
    selectMenuProps: { type: Object, required: true },
  },
};
</script>
